<template>
  <guest-layout>
    <template #navigation>
      <back-arrow page-name="sign-in" />
    </template>
    <template #default>
      <mega-title text="Партнер НГУ" />
      <div class="instruction">
        Чтобы восстановить пароль, введите e-mail, указанный при регистрации. Мы
        отправим на него ссылку для сброса пароля.
      </div>
      <a-form
        ref="formRef"
        :model="formState"
        :rules="rules"
        @finish="executeCaptcha"
        @finishFailed="() => null"
        @submit.prevent
      >
        <YandexSmartCaptcha
          v-if="captchaKey"
          ref="yaCaptcha"
          :siteKey="captchaKey"
          :invisible="true"
          @onSuccess="onCaptchaSuccess"
        />
        <a-form-item name="email">
          <c-input-dadata
            v-model:value="formState.email"
            type="email"
            placeholder="Email*"
          />
        </a-form-item>
        <div class="buttons-block">
          <a-form-item>
            <a-button type="primary" html-type="submit"> Отправить </a-button>
          </a-form-item>
        </div>
      </a-form>
    </template>
  </guest-layout>
</template>

<script>
  import GuestLayout from '@/layouts/GuestLayout';
  import BackArrow from '@/components/navigation/BackArrow';
  import MegaTitle from '@/components/titles/MegaTitle';
  import CInputDadata from '@/components/UI/CInputDadata.vue';
  import { reactive, ref } from 'vue';
  import { useRouter } from 'vue-router';
  import { useApi } from '@/api/use-api';
  import { YandexSmartCaptcha } from '@gladesinger/vue3-yandex-smartcaptcha';

  export default {
    name: 'ResetPasswordRequestPage',
    components: {
      CInputDadata,
      GuestLayout,
      BackArrow,
      MegaTitle,
      YandexSmartCaptcha,
    },
    setup() {
      const router = useRouter();
      const api = useApi();
      const formRef = ref();
      const yaCaptcha = ref(null);
      const captchaKey = process.env.VUE_APP_YANDEX_SMART_CAPTCHA_KEY;

      const formState = reactive({
        email: '',
      });

      const rules = {
        email: [
          {
            required: true,
            type: 'email',
            message: 'Введён некорректный E-Mail',
            trigger: 'change',
          },
        ],
      };

      const executeCaptcha = () => {
        if (yaCaptcha.value) {
          yaCaptcha.value.reset();
          yaCaptcha.value.execute();
        }
      };

      const onCaptchaSuccess = async (token) => {
        try {
          const response = await api.captcha.verifyToken({ token });
          if (response.status === 'ok') {
            await api.password.requestReset({ email: formState.email });
            await router.push({ name: 'reset-password-request-success' });
          } else {
            console.error('Ошибка капчи. Повторите попытку.');
          }
        } catch (error) {
          console.error(
            'Ошибка при отправке запроса на восстановление пароля',
            error
          );
        }
      };

      const onSubmit = () => {
        formRef.value
          .validate()
          .then(executeCaptcha)
          .catch((error) => {
            console.error('Ошибка валидации формы:', error);
          });
      };

      return {
        formRef,
        formState,
        rules,
        onSubmit,
        yaCaptcha,
        captchaKey,
        onCaptchaSuccess,
        executeCaptcha,
      };
    },
  };
</script>

<style lang="scss"></style>
